import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '084c8f4450cf79db247a96ec34aacd2d.png',
	fr: '2645ad2455473d255b94b470a1b53318.png',
	de: '948ae2171c47c06021ca0ac535f81607.png',
	pt: '5ab4f6784744ee705160231862b30615.png',
	'pt-br': '5ab4f6784744ee705160231862b30615.png',
};

export const Recommendations: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'flowlandingpage_title_shapeyourrecommendations_standalone-web',
							{ns: 'flow'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t('flowlandingpage_text_shapeyourrecommendations_standalone-web', {
							ns: 'flow',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					src={src}
					aspectRatio="2048/622"
					alt={t(
						'flowlandingpage_title_shapeyourrecommendations_standalone-web',
						{ns: 'flow'},
					)}
				/>
			}
		/>
	);
};
